<template>
  <section class="doudian-batch-options">
    <el-checkbox
      :value="value.auto_generate_size_chart"
      :disabled="disabled"
      @change="update('auto_generate_size_chart', $event)"
    >
      针对尺码表必填，若尺码表缺失或非法，AI智能生成尺码表
    </el-checkbox>
    <label v-if="showShelfAction" class="doudian-batch-options__shelf">
      同步调整上下架
      <select :value="value.shelf_action" :disabled="disabled" @change="update('shelf_action', Number($event.target.value))">
        <option :value="0">不调整上下架</option>
        <option :value="1">上架</option>
        <option :value="2">下架</option>
      </select>
    </label>
    <p>{{ showShelfAction ? '上下架同样检查尺码表；未勾选时，必填尺码表缺失或非法的商品将执行失败。' : '上架前检查必填尺码表；未勾选自动生成时，缺失或非法的尺码表会导致上架失败。' }}</p>
  </section>
</template>

<script>
export const describeCommonOptions = (value) =>
  `尺码表自动修复：${value.auto_generate_size_chart ? '开' : '关'}；上下架：${['不调整', '上架', '下架'][value.shelf_action]}`

export const batchPreviewNotice = '本次预览依据观星树系统数据，真实修改以同步后的抖店数据为准。'

export default {
  name: 'DoudianBatchCommonOptions',
  props: {
    value: {
      type: Object,
      default: () => ({ auto_generate_size_chart: false, shelf_action: 0 }),
    },
    disabled: Boolean,
    showShelfAction: { type: Boolean, default: true },
  },
  methods: {
    update(key, value) {
      this.$emit('input', { ...this.value, [key]: value })
    },
  },
}
</script>

<style scoped>
.doudian-batch-options {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px 20px;
  margin-bottom: 14px;
  margin-top: 16px;
  padding: 14px;
  border: 1px solid #e0e0ec;
  border-radius: 4px;
  background: #f5f0e8;
}
.doudian-batch-options ::v-deep(.el-checkbox) {
  display: flex;
  align-items: flex-start;
  margin-right: 0;
  min-width: 0;
  max-width: 100%;
}
.doudian-batch-options ::v-deep(.el-checkbox__label) {
  white-space: normal;
  line-height: 1.5;
  font-size: 12px;
}
.doudian-batch-options__shelf {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #606266;
  font-size: 12px;
}
.doudian-batch-options select {
  height: 30px;
  padding: 0 8px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background: #fff;
  color: #606266;
}
.doudian-batch-options p {
  flex-basis: 100%;
  margin: 0;
  color: #909399;
  font-size: 12px;
  line-height: 1.5;
}
</style>
